export const APP_MARKETPLACE_EVENT_CATEGORY = 'app-marketplace';
export const APP_CLICKED = 'AppClicked';
export const APP_RECOMMENDATIONS_LOADED = 'AppRecommendationsLoaded';
export const HOME_PAGE_APP_CLICK = 'homepage-app-click';
export const CAT_PAGE_APP_CLICK = 'cat-app-click';
export const SEARCH_PAGE_APP_CLICK = 'search-app-click';
